<template>
  <swiper class="swiper2" :options="swiperOptions2">
    <swiper-slide class="swiper_img2" v-for="(slide, index) in slides" :key="index">
      <div class="swiper_img2_lefttop">
        <span>17</span>
        <span>2023-11</span>
      </div>
      <img :src="slide" alt="Slide Image">
      <div class="swiper_img2_title">
        <span>我校扎实开展4·15全民国家安全日宣传教育活动</span>
      </div>
    </swiper-slide>
    <div class="swiper-pagination2" slot="pagination"></div>
  </swiper>
</template>
<script>
export default {
  data () {
    return {
      slides: [],
      swiperOptions2: {
        pagination: {el: '.swiper-pagination2', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2000
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/swiper/swiper.vue